"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Recording;
const React = __importStar(require("react"));
const Editor_1 = __importDefault(require("../editor/Editor"));
require("./Recording.scss");
function Recording(props) {
    const [size, setSize] = React.useState({ width: 1080, height: 1080 });
    function render() {
        props.synth.tick();
    }
    React.useEffect(() => {
        if (!props.synth)
            return;
        props.synth.resize(size.width, size.height);
        props.synth.tick();
    }, [props.synth, size]);
    React.useEffect(() => {
        if (!props.synth)
            return;
        props.synth.eval(props.code);
        props.synth.tick();
    }, [props.code]);
    return (React.createElement("div", { className: "recording" },
        React.createElement("canvas", { className: "recording__canvas", ref: props.canvasRef }),
        props.synth && (React.createElement(Editor_1.default, { startValue: props.code, error: props.error, closeError: props.clearError, onRun: props.update })),
        React.createElement(Size, { size: size, onChange: setSize }),
        React.createElement("button", { className: "recording__render", onClick: render }, "RENDER")));
}
function Size({ size, onChange }) {
    const widths = [1920, 2048, 1080, 400, 0];
    const heights = [1080, 2048, 1080, 400, 0];
    return (React.createElement("div", { className: "recording__size" },
        React.createElement("select", { value: size.width, onChange: e => onChange({ width: parseInt(e.target.value), height: size.height }) }, widths.map((width, i) => (React.createElement("option", { key: i, value: width }, width)))),
        React.createElement("select", { value: size.height, onChange: e => onChange({ width: size.width, height: parseInt(e.target.value) }) }, heights.map((height, i) => (React.createElement("option", { key: i, value: height }, height))))));
}
